import { render, staticRenderFns } from "./PreatzioniAmbulatorioaliModalComponent.vue?vue&type=template&id=34d2df0d"
import script from "./PreatzioniAmbulatorioaliModalComponent.vue?vue&type=script&lang=js"
export * from "./PreatzioniAmbulatorioaliModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports